"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reorderProjectRolesRequestSchema = exports.updateProjectRoleRequestSchema = exports.createProjectRoleRequestSchema = exports.projectRoleSchema = void 0;
const zod_1 = require("zod");
const identifier_1 = require("../identifier");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ C31 · Project roles — what somebody DOES on a project.                    │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * The mockup's `PROJECT_ROLES`: Tech Lead, Projektvezető, Frontend, Backend, QA, Designer, DevOps.
 * A workspace vocabulary, edited beside task statuses and priorities.
 *
 * ⚠️⚠️ **NOT A PERMISSION, AND THE NAMING COLLISION IS THE WHOLE RISK.** `permissions/` has `Role`,
 * which grants actions at a scope and is the only thing `CheckService` reads. This is a **label**
 * for reports and for the people list. The type is called `ProjectRole` everywhere — never `Role` —
 * so an import cannot quietly bring the wrong one into an authorisation path. Migration `0058`
 * makes the same argument at the table.
 */
const colorSchema = zod_1.z.string().regex(/^#[0-9A-Fa-f]{6}$/);
exports.projectRoleSchema = zod_1.z.object({
    id: zod_1.z.string(),
    /** `project_role_9d3b6e4a` — the public identifier `0194` mints beside the uuid; see `identifier.ts`. */
    identifier: (0, identifier_1.identifierSchema)('projectRole'),
    name: zod_1.z.string(),
    color: colorSchema,
    position: zod_1.z.number().int(),
    /**
     * How many project memberships wear it.
     *
     * ⚠️ **The delete confirm cannot ask its question without this** — the same argument
     * `metafields` makes for `usageCount`: *"7 projekttagságon van beállítva"* is answerable, "are you
     * sure?" is not. Deleting nulls those memberships' role rather than refusing, so the number is
     * what somebody is agreeing to lose.
     */
    usageCount: zod_1.z.number().int().nonnegative(),
    version: zod_1.z.number().int().positive(),
});
exports.createProjectRoleRequestSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(60),
    color: colorSchema,
});
exports.updateProjectRoleRequestSchema = zod_1.z.object({
    name: zod_1.z.string().trim().min(1).max(60).optional(),
    color: colorSchema.optional(),
    version: zod_1.z.number().int().positive(),
});
/**
 * ⚠️ **Reorder is the whole list, not a pair of indices.** The mockup drags a row and drops it; the
 * result is an order, and sending it whole means the server never has to reconstruct what the
 * reader saw. `metafields`' own reorder is the same shape, and this reuses its reasoning rather
 * than inventing a second one.
 */
exports.reorderProjectRolesRequestSchema = zod_1.z.object({ ids: zod_1.z.array(zod_1.z.uuid()).max(50) });
//# sourceMappingURL=project-roles.js.map